export const CONFIRM_LABEL = 'Confirm'
export const SAVE_LABEL = 'Save changes'

function trimmed(value) {
  return String(value === null || value === undefined ? '' : value).trim()
}

// Measured against the name the step arrived with rather than against the last
// keystroke, so a merchant who types over the name and puts it back is offered
// the confirm again instead of being told they have changes to save. A name the
// journey never wrote is nothing to confirm: the merchant has to supply one, and
// the submit stays shut until they do.
export function storeDetailsAction(typedName, savedName) {
  const typed = trimmed(typedName)
  const saved = trimmed(savedName)
  return {
    label: saved && typed === saved ? CONFIRM_LABEL : SAVE_LABEL,
    submittable: typed.length > 0
  }
}
